const getters = {
  size: state => state.app.size,
  device: state => state.app.device,
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  errorLogs: state => state.errorLog.logs,
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  add_routes: state => state.user.addRoutes,
  permission_routes: state => state.user.routes,
  permission_btnList: state => state.user.btns,
  pageConfigName:state=>state.page.pageType[state.page.floorSetup.typeIndex]
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js